export default function CTASection() {
  return (
    <section id="download" className="py-16 px-4 bg-primary-600 text-white text-center">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold font-cairo mb-3 anim-fade-up">حمّل التطبيق وابدأ الآن</h2>
        <p className="text-white/70 mb-8 max-w-md mx-auto anim-fade-up delay-1">
          اشتراك شهري واحد يفتح لك أبواب جميع المغاسل الشريكة في العراق
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 anim-fade-up delay-2">
          <a
            href="#download"
            className="flex items-center gap-3 bg-white text-primary-700 font-semibold text-sm py-3.5 px-7 rounded-full hover:bg-white/90 transition-colors"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/></svg>
            App Store
          </a>
          <a
            href="#download"
            className="flex items-center gap-3 bg-white/10 border border-white/20 text-white font-semibold text-sm py-3.5 px-7 rounded-full hover:bg-white/20 transition-colors"
          >
            <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5"><path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.199l2.144 1.24a1 1 0 0 1 0 1.732l-2.144 1.24-2.53-2.53 2.53-2.682zM5.864 2.658L16.8 9.39l-2.302 2.302-8.634-8.635z"/></svg>
            Google Play
          </a>
        </div>
      </div>
    </section>
  );
}
